import InteractiveBanners03 from '../../../Components/InteractiveBanners/InteractiveBanners03'
import { fadeIn } from '../../../Functions/GlobalAnimations'

const Tiles = ({ title, data }) => {
    return (
        <section>
            <div className="mt-[70px]">
                <InteractiveBanners03
                    grid="row-cols-1 gap-y-10"
                    overlay={["#0000004a", "#0000004a"]}
                    data={data}
                    animation={fadeIn} />
            </div>
            <div className="mx-auto border-b border-gray-300 w-[40%] mt-5" />
        </section>
    )
}

export default Tiles